import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const SearchBack = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clip-path="url(#clip0_1406_1197)">
      <path d="M15.0032 19.5037L7.50195 12.0024L15.0032 4.50116" stroke="#4D4D4D" strokeWidth="1.50026" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1406_1197">
        <rect width="24.0041" height="24.0041" fill="white" />
      </clipPath>
    </defs>
  </svg>);
export default SearchBack;